import { useMediaQuery } from "@material-ui/core";

import isEquipeChatMobileApp from "../utils/isEquipeChatMobileApp";
import isEquipeChatDesktopShell from "../utils/isEquipeChatDesktopShell";

const DESKTOP_POINTER_QUERY = "(hover: hover) and (pointer: fine)";

const useIsDesktopBrowserLayout = () => {
  const matchesDesktopPointer = useMediaQuery(DESKTOP_POINTER_QUERY, {
    noSsr: true,
  });

  if (isEquipeChatDesktopShell()) {
    return true;
  }

  if (isEquipeChatMobileApp()) {
    return false;
  }

  return matchesDesktopPointer;
};

export default useIsDesktopBrowserLayout;
